<template>
  <div id="app" class="ma-lg-10 ml-lg-10 ma-md-10 ml-md-10 no-xhide">
    <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" transition="slide-x-reverse-transition" v-model="successSnackbar" :timeout="4000" :value="true" color="#43A833" text-color="white">
      <v-icon class="mr-2" color="white">mdi-check-circle-outline</v-icon>
      {{ mesg }}
      <v-icon @click="successSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
    </v-snackbar>

    <v-snackbar class="pt-6 pr-md-6 snakbar-sty rounded-pill" elevation="0" transition="slide-x-reverse-transition" v-model="errorSnackbar" :timeout="4000" :value="true" color="error" text-color="white">
      <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
      {{ errtext }}
      <v-icon @click="errorSnackbar = false" class="float-right" color="white">mdi-close-circle</v-icon>
    </v-snackbar>

    <div class="mx-3 px-1">
      <!-- ================= HERO ================= -->
      <v-card class="py-md-6 px-md-6 pa-4 mt-6" elevation="0" outlined width="100%" rounded="lg">
        <v-row no-gutters align="center">
          <v-col cols="12" md="7" class="pr-md-6">
            <p class="mb-2" style="color: #0037b7; font-size: 13px; font-weight: 559; line-height: 18px" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub' : ''">Refer your friends to Zebu</p>
            <p class="mb-3" style="color: #000000; font-size: 34px; font-weight: 559; line-height: 42px; letter-spacing: -1px" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-hero title-align' : ''">Your <span style="color: #0037b7">word</span> is worth more</p>
            <p class="subtitle-2 ref-body mb-0 ref-hero-body" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub sub-align' : ''">Someone once helped you take your first step in the market. Now it's your turn. Share Zebu with the friends and family you want to see grow — because their journey matters to you.</p>
          </v-col>

          <!-- conversation preview -->
          <v-col cols="12" md="5" class="mt-6 mt-md-0 ref-chat-col">
            <v-card elevation="0" outlined rounded="lg" class="pa-3 ref-chat-card">
              <div class="d-flex align-start">
                <v-avatar size="34" color="#F1F3F8" class="mr-3">
                  <span class="text-uppercase font-weight-bold fs-14" style="color: #0037b7">{{ initial }}</span>
                </v-avatar>
                <div class="flex-grow-1">
                  <p class="ref-label fs-12 fw-600 mb-1">You, to a friend</p>
                  <p class="body-2 black--text font-weight-regular mb-0" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub' : ''">"I've been trading with Zebu for a while now. Thought of you — I think you'd really like it."</p>
                </div>
              </div>
            </v-card>
            <div class="d-flex justify-end mt-2">
              <div class="ref-reply ref-reply-shadow rounded-lg px-3 py-2 body-2 black--text" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub' : ''">"That means a lot. Send me the link!"</div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <!-- ================= STEP 1 & 2 ================= -->
      <v-row class="mt-1">
        <v-col cols="12" md="6">
          <v-card class="py-md-6 px-md-6 pa-4 fill-height" elevation="0" outlined width="100%" rounded="lg">
            <p class="mb-1" style="color: #000000; font-size: 16px; font-weight: 559; line-height: 22px; letter-spacing: -0.2px" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"><span style="color: #0037b7" class="mr-1">1.</span> Share your referral link</p>
            <p class="subtitle-2 ref-body mb-6" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub sub-align' : ''">Copy the referral link below and share it with your family and friends.</p>

            <div class="ref-link-box rounded-pill d-flex align-center px-4">
              <v-icon size="18" color="#444444" class="mr-3">mdi-account-outline</v-icon>
              <div class="flex-grow-1 text-truncate">
                <v-skeleton-loader v-if="btnenable" type="text" max-width="220" class="mt-3"></v-skeleton-loader>
                <span v-else class="black--text fs-14 fw-600">{{ referralLink }}</span>
              </div>
              <v-btn icon small :disabled="btnenable" title="Copy link" @click="copyText(referralLink, 'Link copied.')">
                <v-icon size="18" color="#444444">mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card :class="['py-md-6 px-md-6 pa-4', $vuetify.breakpoint.mdAndUp ? 'fill-height' : '']" elevation="0" outlined width="100%" rounded="lg">
            <p class="mb-1" style="color: #000000; font-size: 16px; font-weight: 559; line-height: 22px; letter-spacing: -0.2px" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''"><span style="color: #0037b7" class="mr-1">2.</span> Refer your family and friends</p>
            <p class="subtitle-2 ref-body mb-5" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub sub-align' : ''">We've written the message for you — edit it, or send it as is.</p>

            <div class="d-sm-flex">
              <v-btn :disabled="btnenable" :href="whatsappUrl" target="_blank" rel="noopener noreferrer" elevation="0" color="black" rounded :block="$vuetify.breakpoint.xsOnly" class="text-none mr-sm-3 mb-3 mb-sm-0">
                <v-icon size="18" color="#ffffff" class="mr-2">mdi-whatsapp</v-icon>
                <span class="white--text">Refer on whatsapp</span>
              </v-btn>
              <v-btn :disabled="btnenable" @click="shareViaWebShare" elevation="0" color="#F1F3F8" rounded :block="$vuetify.breakpoint.xsOnly" class="text-none"> More ways to share </v-btn>
            </div>

            <div class="ref-msg-box rounded-lg mt-5 pl-4 pr-2 py-2 d-flex align-start" :class="$vuetify.breakpoint.smAndDown ? 'ref-msg-box--fluid' : ''">
              <div class="flex-grow-1">
                <v-textarea v-model="message" :disabled="btnenable" class="ref-msg-input body-2 mt-0 pt-0" :rows="$vuetify.breakpoint.smAndDown ? 4 : 2" auto-grow hide-details flat solo background-color="transparent" placeholder="Write your own message..."></v-textarea>
                <a class="ref-msg-link fs-14 fw-600" style="color: #0037b7" :href="referralLink" target="_blank" rel="noopener noreferrer">{{ referralLink }}</a>
              </div>
              <div class="d-flex ml-2 mt-1">
                <v-btn icon small class="mr-1" :disabled="btnenable || message === defaultMessage" title="Reset to the default message" @click="resetMessage">
                  <v-icon size="17" color="#444444">mdi-refresh</v-icon>
                </v-btn>
                <v-btn icon small :disabled="btnenable" title="Copy message" @click="copyText(message + ' ' + referralLink, 'Message copied.')">
                  <v-icon size="16" color="#444444">mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- ================= HOW IT WORKS ================= -->
      <div class="px-md-3 mt-8">
        <p class="mb-1" style="color: #000000; font-size: 20px; font-weight: 559; line-height: 24px; letter-spacing: -1px" :class="$vuetify.breakpoint.smAndDown ? 'title-align mobile-version-title' : ''">Three steps, start to finish</p>
        <p class="subtitle-2 ref-body mb-0" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub sub-align' : ''">Copy your link, share it with someone you care about, and they open their account in minutes.</p>
      </div>

      <v-row class="mt-1 mb-md-6">
        <v-col cols="12" md="4" v-for="(s, i) in steps" :key="i">
          <v-card class="py-md-5 px-md-5 pa-4 fill-height d-flex" elevation="0" outlined width="100%" rounded="lg">
            <span class="mr-4" style="color: #0037b7; font-size: 22px; font-weight: 559; line-height: 26px">{{ i + 1 }}</span>
            <div>
              <p class="mb-1" style="color: #000000; font-size: 16px; font-weight: 559; line-height: 22px; letter-spacing: -0.2px" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub1' : ''">{{ s.title }}</p>
              <p class="subtitle-2 ref-body mb-0" :class="$vuetify.breakpoint.smAndDown ? 'mobile-version-sub sub-align' : ''">{{ s.desc }}</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    successSnackbar: false,
    errorSnackbar: false,
    mesg: "",
    errtext: "",

    clientid: "",
    cname: "",
    referralLink: "",
    btnenable: true,
    btnload: false,

    defaultMessage: "Hey! I've been trading with Zebu for a while, and it's honestly made things easier for me. I thought of you — if you're ever planning to start investing, this is my link:",
    message: "Hey! I've been trading with Zebu for a while, and it's honestly made things easier for me. I thought of you — if you're ever planning to start investing, this is my link:",
    steps: [
      { title: "Copy your link", desc: "It identifies you as the referrer — nothing else changes." },
      { title: "Share it with someone", desc: "WhatsApp works best. Your words, or ours." },
      { title: "They start in minutes", desc: "Fully digital account opening. You just helped someone you care about take their first step." },
    ],
  }),
  computed: {
    initial() {
      var n = this.cname || this.clientid || "";
      return n ? n.trim().charAt(0).toUpperCase() : "Y";
    },
    whatsappUrl() {
      return "https://wa.me/?text=" + encodeURIComponent(this.message + " " + this.referralLink);
    },
  },
  methods: {
    getrefferalUrl() {
      this.btnload = true;
      var respdata = "https://oa.mynt.in/?ref=";
      var config = {
        method: "get",
        url: "https://dwld.zebuetrade.com/gen?id=" + this.clientid,
        headers: {},
      };

      let axiosThis = this;
      axios(config)
        .then(function (response) {
          if (response.data.link != "Invalid") {
            axiosThis.referralLink = respdata + axiosThis.clientid;
            axiosThis.btnenable = false;
          } else {
            axiosThis.referralLink = "";
            axiosThis.btnenable = true;
            axiosThis.errorSnackbar = true;
            axiosThis.errtext = "Invalid Client ID.";
          }
          axiosThis.btnload = false;
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.btnload = false;
        });
    },

    resetMessage() {
      this.message = this.defaultMessage;
    },

    shareViaWebShare() {
      if (navigator.share) {
        navigator.share({
          title: "Zebu",
          text: this.message,
          url: this.referralLink,
        });
      } else {
        this.copyText(this.message + " " + this.referralLink, "Message copied.");
      }
    },

    copyText(txt, msg) {
      navigator.clipboard.writeText(txt);
      this.successSnackbar = true;
      this.mesg = msg;
    },
  },
  mounted() {
    this.clientid = localStorage.getItem("userid");
    this.cname = localStorage.getItem("cname");
    this.getrefferalUrl();
  },
};
</script>

<style scoped>
/* app mobile type-scale - same tokens used across the profile screens */
.mobile-version-title {
  font-size: 22px !important;
}

.mobile-version-hero {
  font-size: 28px !important;
  line-height: 34px !important;
}

.mobile-version-subtitle {
  font-size: 15px !important;
}

.mobile-version-sub {
  font-size: 14px !important;
}

.mobile-version-sub1 {
  font-size: 18px !important;
}

.sub-align {
  line-height: 18px !important;
  letter-spacing: 0.015rem !important;
}

.title-align {
  letter-spacing: 0.01rem !important;
}

/* body copy sits at a fixed reading width so the chat preview keeps its breathing space */
@media only screen and (min-width: 960px) {
  .ref-hero-body {
    width: 640px;
    max-width: 100%;
  }

  .ref-chat-col {
    max-width: 470px;
    margin-left: auto;
    margin-right: 48px;
    padding-left: 40px;
  }
}

/* text colours - one step darker than the app default for better legibility */
.ref-body {
  color: #3d3d3d !important;
  font-weight: 469 !important;
}

.ref-label {
  color: #444444 !important;
}

.ref-reply {
  background-color: #ecf8f1 !important;
  border: 1px solid #c1e7ba !important;
  max-width: 90%;
}

/* premium shadow for the hero chat sender card */
.ref-chat-card {
  box-shadow:
    0 2px 8px rgba(0, 55, 183, 0.08),
    0 8px 24px rgba(0, 55, 183, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.06) !important;
  border-color: rgba(0, 55, 183, 0.15) !important;
  transition: box-shadow 0.25s ease !important;
}

/* .ref-chat-card:hover {
  box-shadow:
    0 4px 14px rgba(0, 55, 183, 0.13),
    0 16px 36px rgba(0, 55, 183, 0.16),
    0 1px 3px rgba(0, 0, 0, 0.08) !important;
} */

/* premium shadow for the reply bubble */
.ref-reply-shadow {
  box-shadow:
    0 2px 8px rgba(67, 168, 51, 0.12),
    0 6px 20px rgba(67, 168, 51, 0.14),
    0 1px 2px rgba(0, 0, 0, 0.05) !important;
  transition: box-shadow 0.25s ease !important;
}

.ref-link-box {
  height: 48px;
  background-color: #f1f3f8 !important;
}

.ref-msg-box {
  background-color: #f1f3f8 !important;
  border-left: 3px solid #43a833 !important;
}

/* on mobile the box height is purely content-driven — no fixed constraint */
.ref-msg-box--fluid {
  height: auto !important;
  min-height: unset !important;
  max-height: none !important;
}

/* editable message - textarea styled to read as plain text */
.ref-msg-input ::v-deep .v-input__slot {
  padding: 0 !important;
  background-color: transparent !important;
}

.ref-msg-input ::v-deep textarea {
  color: #000000 !important;
  font-size: 14px !important;
  font-weight: 469 !important;
  line-height: 21px !important;
  margin-top: 0 !important;
  padding-top: 6px !important;
}

.ref-msg-link {
  display: inline-block;
  line-height: 21px !important;
  text-decoration: none !important;
  word-break: break-all !important;
  padding-bottom: 6px;
}
</style>

<!-- global helpers declared here and consumed by other screens - do not remove -->
<style lang="scss">
.no-xhide {
  overflow: hidden !important;
}

.pos-rlt {
  position: relative !important;
}

.white-space {
  white-space: pre-line !important;
}
</style>
